export enum VersionIOT {
  v10 = 'v_1_0',
  v20 = 'v_2_0',
  v21 = 'v_2_1'
}
